<template>
    <div class="ipoint-success">
        <message type="success" msg="我怎么知道呢"></message>
        <div class="ipoint-success-content">
            <img src="../../assets/profile/success.png" alt="">
            <p>Ipoint successful transfer to your friends</p>
        </div>
    </div>
</template>
<script>
    import message from './Common/Message.vue'

    export default {
        components: {
            message
        }
    }
</script>
<style lang="scss">
    .ipoint-success {
        margin-top: 80px;
    }

    .ipoint-success-content {
        width: 80%;
        margin: 0 auto;
        background-color: white;
        padding: 50px 150px;
        margin-bottom: 200px;
        p {
            font-size: 24px;
            color: #5E6D82;
            letter-spacing: 0
        }

    }
</style>



// WEBPACK FOOTER //
// iPointTransfer.vue?738f8245